import AWS from 'aws-sdk';

// Set up AWS credentials (either from environment variables or manually)
AWS.config.update({
  accessKeyId: import.meta.env.VITE_AWS_ACCESS_KEY_ID,
  secretAccessKey: import.meta.env.VITE_AWS_SECRET_ACCESS_KEY,
  region: "ap-south-1"  
});

export async function putAws(url, data) {
  const endpoint = url;
  const method = 'PUT';
  const body = JSON.stringify(data);

  // Sign the request using AWS Signature Version 4
  const request = new AWS.HttpRequest(new AWS.Endpoint(endpoint), AWS.config.region);
  request.method = method;
  request.headers['Host'] = request.endpoint.host;
  request.headers['Content-Type'] = 'application/json';
  request.body = body;

  const signer = new AWS.Signers.V4(request, 'execute-api');
  signer.addAuthorization(AWS.config.credentials, new Date());

  // Use fetch to make the request
  try {
      const response = await fetch(endpoint, {
          method,
          headers: {
              ...request.headers,
          },
          body,
      });

      const responseData = await response.json();
      console.log('Response:', responseData);
      return responseData;
  } catch (error) {
      console.error('Error:', error);
      throw error;
  }
}



